import Rate from '@/components/Rate';
import Image from 'next/image';
import Link from 'next/link';
import { useRef } from 'react';
import CutOffText from '../CutOffText';
import useAboutReviews from './useAboutReviews';

function formatNumber(num) {
  if (num >= 10000) {
    const thousands = Math.floor(num / 1000);
    return `${thousands},000+`;
  } else {
    return num?.toLocaleString();
  }
}

const AboutReviews = () => {
  const { reviewsCount, reviews } = useAboutReviews();

  const containerRef = useRef(null);
  let isDragging = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = e => {
    isDragging = true;
    containerRef.current.style.cursor = 'grabbing';
    containerRef.current.style.userSelect = 'none'; // 禁用文本选择
    startX = e.pageX - containerRef.current.offsetLeft;
    scrollLeft = containerRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDragging = false;
    containerRef.current.style.cursor = 'grab';
    containerRef.current.style.userSelect = ''; // 恢复文本选择
  };

  const handleMouseUp = () => {
    isDragging = false;
    containerRef.current.style.cursor = 'grab';
    containerRef.current.style.userSelect = ''; // 恢复文本选择
  };

  const handleMouseMove = e => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // 滚动速度

    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className='mt-[60px] px-[17px] lg_px-0'>
      <div className='mx-auto w-[1440px] max-w-full'>
        <div className='mb-[30px] flex items-end justify-between font-poppins text-[22px] font-[600] leading-[1.4] text-title lg_text-[30px]'>
          <h2 className='flex-1'>Voice From Our Community</h2>
          <div className='hidden shrink-0 items-center lg_flex'>
            <div className='hidden items-center lg_flex'>
              <Link
                href='/reviews'
                className=' ml-[20px] font-sans text-[16px] font-normal uppercase text-primary underline'
              >
                read more
              </Link>
            </div>

            <Link
              href='/reviews'
              className='font-sans text-[16px] font-normal uppercase text-primary underline lg_hidden'
            >
              Read more
            </Link>
          </div>
        </div>

        <div className='w-full'>
          <div
            id='scroll-container'
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            className='flex overflow-x-auto whitespace-nowrap pb-[40px]'
          >
            {reviews &&
              reviews.map((item, index) => (
                <div
                  className='mr-[20px] w-[280px] shrink-0 select-none rounded-[20px] bg-[#F7F7F5] p-[20px] lg_mr-[26px] lg_w-[340px] lg_p-[30px]'
                  key={index}
                  draggable={false}
                >
                  <div className='flex w-full flex-col'>
                    <Image
                      src={item.product.small_image.url}
                      alt=''
                      width={384}
                      height={384}
                      draggable={false}
                    />
                    <div className='mt-[20px]'>
                      <Rate
                        disabled
                        initialRating={item.average_rating}
                      />
                    </div>

                    <p className=' mt-[15px] whitespace-normal text-left font-poppins font-[600] leading-[1.4] text-title'>
                      {item.summary}
                    </p>
                    <p className='mt-[5px] whitespace-normal font-poppins text-sm leading-[1.4] text-[#666]'>
                      <CutOffText
                        text={item.text}
                        length={250}
                      />
                    </p>
                    <p className='mt-[15px] font-poppins text-sm font-[600] leading-[1.2] text-title'>
                      {item.nickname}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutReviews;
